import { cloneDeep } from 'lodash';

import { i18n } from 'core/localization';
import { ApplicationState } from 'framework/applicationState';
import { DesignerStore } from 'controls/designer/designerStore';

import { DataSourceDataGridWidget } from './index';
import { DataSourceDataGridWidgetConfigEditor } from './editor';
import { DataSourceDataGridWidgetConfig } from './types';

export function getWidgetDescription() {
	return {
		form: DataSourceDataGridWidgetConfigEditor,
		defaultConfig: {
			type: 'data-sources-grid',
			title: i18n('Datasource grid'),
			accountId: ApplicationState.accountId,
			dataSourceSelectorAccountId: null,
			gridToolbarVisibility: {},
			decimalsNumber: 0,
			categoryColumns: undefined,
			dataColumns: undefined,
			dataRows: undefined,
			pivotRows: undefined,
			pivotColumns: undefined,
			pivotValues: undefined,
			pivotData: undefined,
			pivotMatrix: undefined,
			splitPivotValues: undefined,
		} as DataSourceDataGridWidgetConfig,
		minWidth: 800,
		widget: DataSourceDataGridWidget,
		fullTitle: i18n('Datasource grid'),
		preProcessConfig: (config: DataSourceDataGridWidgetConfig, store: DesignerStore) => {
			config = cloneDeep(config);
			if (config.dataSourceSelectorAccountId === undefined) {
				config.dataSourceSelectorAccountId = config.accountId;
			}
			if (store.config.accountId) {
				config.accountId = store.config.accountId;
			}
			return config;
		},
	};
}
